/**
 * ABR Interactions v4
 * Immersive scroll system: parallax depth, split-text reveals,
 * scroll-scrub progress, header state, cursor glow, chapter reveals.
 */
(function () {
  'use strict';

  var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ═══════════════════════════════════════════════════
     SCROLL REVEAL — data-abr-scroll-reveal
  ═══════════════════════════════════════════════════ */
  function initScrollReveal() {
    var els = document.querySelectorAll('[data-abr-scroll-reveal]');
    if (!els.length) return;
    if (reduced) { els.forEach(function(el) { el.classList.add('is-revealed'); }); return; }
    var io = new IntersectionObserver(function(entries) {
      entries.forEach(function(entry) {
        if (entry.isIntersecting) {
          var delay = parseInt(entry.target.getAttribute('data-abr-delay') || '0', 10);
          setTimeout(function() { entry.target.classList.add('is-revealed'); }, delay);
          io.unobserve(entry.target);
        }
      });
    }, { threshold: 0.08, rootMargin: '0px 0px -40px 0px' });
    els.forEach(function(el) { io.observe(el); });
  }

  /* ═══════════════════════════════════════════════════
     HERO REVEAL — data-abr-reveal (load-time)
  ═══════════════════════════════════════════════════ */
  function initHeroReveal() {
    var els = document.querySelectorAll('[data-abr-reveal]');
    if (!els.length) return;
    if (reduced) { els.forEach(function(el) { el.classList.add('is-revealed'); }); return; }
    els.forEach(function(el) {
      var delay = parseInt(el.getAttribute('data-abr-delay') || '0', 10);
      setTimeout(function() { el.classList.add('is-revealed'); }, delay + 200);
    });
  }

  /* ═══════════════════════════════════════════════════
     CHAPTER REVEALS — about page
  ═══════════════════════════════════════════════════ */
  function initChapterReveal() {
    var chapters = document.querySelectorAll('.abr-about__chapter');
    if (!chapters.length) return;
    if (reduced) { chapters.forEach(function(c) { c.classList.add('is-revealed'); }); return; }
    var io = new IntersectionObserver(function(entries) {
      entries.forEach(function(e) {
        if (e.isIntersecting) { e.target.classList.add('is-revealed'); io.unobserve(e.target); }
      });
    }, { threshold: 0.1, rootMargin: '0px 0px -40px 0px' });
    chapters.forEach(function(c) { io.observe(c); });
  }

  /* ═══════════════════════════════════════════════════
     BLOOD LINE / RULE REVEALS
  ═══════════════════════════════════════════════════ */
  function initBloodLines() {
    var io = new IntersectionObserver(function(entries) {
      entries.forEach(function(e) {
        if (e.isIntersecting) { e.target.classList.add('is-in-view'); io.unobserve(e.target); }
      });
    }, { threshold: 0.3 });
    document.querySelectorAll('.abr-about__rule, .abr-mfst, .abr-prod__rule').forEach(function(el) {
      io.observe(el);
    });
  }

  /* ═══════════════════════════════════════════════════
     CONTACT LEFT REVEAL
  ═══════════════════════════════════════════════════ */
  function initContactLines() {
    var io = new IntersectionObserver(function(entries) {
      entries.forEach(function(e) {
        if (e.isIntersecting) { e.target.classList.add('is-revealed'); io.unobserve(e.target); }
      });
    }, { threshold: 0.2 });
    document.querySelectorAll('.abr-contact__left').forEach(function(el) { io.observe(el); });
  }

  /* ═══════════════════════════════════════════════════
     HEADER SCROLL STATE
  ═══════════════════════════════════════════════════ */
  function initHeaderScroll() {
    var header = document.querySelector('header-component') ||
                 document.querySelector('.header-wrapper') ||
                 document.querySelector('.header');
    if (!header) return;
    var ticking = false;
    function update() {
      var scrolled = window.scrollY > 60;
      if (scrolled) {
        header.setAttribute('data-scrolled', '');
        header.classList.add('header--scrolled');
        if (header.parentElement) header.parentElement.classList.add('header-wrapper--scrolled');
      } else {
        header.removeAttribute('data-scrolled');
        header.classList.remove('header--scrolled');
        if (header.parentElement) header.parentElement.classList.remove('header-wrapper--scrolled');
      }
      ticking = false;
    }
    window.addEventListener('scroll', function() {
      if (!ticking) { requestAnimationFrame(update); ticking = true; }
    }, { passive: true });
    update();
  }

  /* ═══════════════════════════════════════════════════
     PARALLAX — subtle depth on layered elements
  ═══════════════════════════════════════════════════ */
  function initParallax() {
    if (reduced || window.innerWidth < 768) return;
    var targets = document.querySelectorAll('[data-abr-parallax]');
    if (!targets.length) return;
    var ticking = false;
    window.addEventListener('scroll', function() {
      if (!ticking) {
        requestAnimationFrame(function() {
          var sy = window.scrollY;
          targets.forEach(function(el) {
            var speed = parseFloat(el.getAttribute('data-abr-parallax') || '0.12');
            el.style.transform = 'translateY(' + (sy * speed) + 'px)';
          });
          ticking = false;
        });
        ticking = true;
      }
    }, { passive: true });
  }

  /* ═══════════════════════════════════════════════════
     SCROLL PROGRESS BAR — thin crimson line at top
  ═══════════════════════════════════════════════════ */
  function initScrollProgress() {
    if (reduced) return;
    var bar = document.createElement('div');
    bar.id = 'abr-scroll-progress';
    bar.style.cssText = [
      'position:fixed', 'top:0', 'left:0', 'height:2px', 'width:0%',
      'background:linear-gradient(to right, #8B0000, #C41E3A)',
      'z-index:99999', 'pointer-events:none',
      'transition:width 0.1s linear',
      'box-shadow:0 0 8px rgba(139,0,0,0.6)'
    ].join(';');
    document.body.appendChild(bar);
    var ticking = false;
    window.addEventListener('scroll', function() {
      if (!ticking) {
        requestAnimationFrame(function() {
          var docH = document.documentElement.scrollHeight - window.innerHeight;
          var pct = docH > 0 ? (window.scrollY / docH) * 100 : 0;
          bar.style.width = pct + '%';
          ticking = false;
        });
        ticking = true;
      }
    }, { passive: true });
  }

  /* ═══════════════════════════════════════════════════
     STAGGERED CARD REVEAL — collection grid
  ═══════════════════════════════════════════════════ */
  function initCardReveal() {
    if (reduced) return;
    var cards = document.querySelectorAll('.template-collection .card-wrapper');
    if (!cards.length) return;
    cards.forEach(function(el, i) {
      el.style.opacity = '0';
      el.style.transform = 'translateY(24px)';
      el.style.transition = 'opacity 0.75s cubic-bezier(0.22,1,0.36,1), transform 0.75s cubic-bezier(0.22,1,0.36,1)';
      el.style.transitionDelay = (i % 4 * 0.09) + 's';
    });
    var io = new IntersectionObserver(function(entries) {
      entries.forEach(function(e) {
        if (e.isIntersecting) {
          e.target.style.opacity = '1';
          e.target.style.transform = 'translateY(0)';
          io.unobserve(e.target);
        }
      });
    }, { threshold: 0.05, rootMargin: '0px 0px -20px 0px' });
    cards.forEach(function(el) { io.observe(el); });
  }

  /* ═══════════════════════════════════════════════════
     CURSOR GLOW
  ═══════════════════════════════════════════════════ */
  function initCursorGlow() {
    if (reduced || 'ontouchstart' in window || window.innerWidth < 1024) return;
    var glow = document.createElement('div');
    glow.id = 'abr-cursor-glow';
    glow.style.cssText = [
      'position:fixed', 'pointer-events:none', 'z-index:9998',
      'width:350px', 'height:350px', 'border-radius:50%',
      'background:radial-gradient(circle, rgba(139,0,0,0.07) 0%, transparent 60%)',
      'transform:translate(-50%,-50%)', 'opacity:0',
      'transition:opacity 0.4s ease', 'top:0', 'left:0', 'will-change:transform'
    ].join(';');
    document.body.appendChild(glow);
    var mx = 0, my = 0, cx = 0, cy = 0;
    document.addEventListener('mousemove', function(e) { mx = e.clientX; my = e.clientY; glow.style.opacity = '1'; }, { passive: true });
    document.addEventListener('mouseleave', function() { glow.style.opacity = '0'; });
    (function animate() {
      cx += (mx - cx) * 0.08; cy += (my - cy) * 0.08;
      glow.style.left = cx + 'px'; glow.style.top = cy + 'px';
      requestAnimationFrame(animate);
    }());
  }

  /* ═══════════════════════════════════════════════════
     SECTION ENTRANCE — generic sections fade up
  ═══════════════════════════════════════════════════ */
  function initSectionEntrance() {
    if (reduced) return;
    var sections = document.querySelectorAll(
      '.abr-showcase, .abr-manifesto, .abr-prod, .abr-cat-banner'
    );
    if (!sections.length) return;
    var io = new IntersectionObserver(function(entries) {
      entries.forEach(function(e) {
        if (e.isIntersecting) {
          e.target.classList.add('abr-section-visible');
          io.unobserve(e.target);
        }
      });
    }, { threshold: 0.06 });
    sections.forEach(function(s) {
      if (!s.classList.contains('abr-section-visible')) {
        s.style.opacity = '0';
        s.style.transform = 'translateY(20px)';
        s.style.transition = 'opacity 1s cubic-bezier(0.22,1,0.36,1), transform 1s cubic-bezier(0.22,1,0.36,1)';
      }
      io.observe(s);
    });
    document.addEventListener('abr:section:visible', function(e) {
      if (e.target) { e.target.style.opacity = '1'; e.target.style.transform = 'none'; }
    });
  }

  /* Add visible class handler */
  document.addEventListener('animationend', function() {}, false);
  var sectionIO = new IntersectionObserver(function(entries) {
    entries.forEach(function(e) {
      if (e.isIntersecting) {
        e.target.style.opacity = '1';
        e.target.style.transform = 'none';
      }
    });
  }, { threshold: 0.06 });
  document.querySelectorAll('.abr-showcase, .abr-manifesto, .abr-prod, .abr-cat-banner').forEach(function(s) {
    if (!reduced) {
      s.style.opacity = '0';
      s.style.transform = 'translateY(20px)';
      s.style.transition = 'opacity 1s cubic-bezier(0.22,1,0.36,1), transform 1s cubic-bezier(0.22,1,0.36,1)';
      sectionIO.observe(s);
    }
  });

  /* ═══════════════════════════════════════════════════
     INIT
  ═══════════════════════════════════════════════════ */
  function init() {
    initScrollReveal();
    initHeroReveal();
    initChapterReveal();
    initBloodLines();
    initContactLines();
    initHeaderScroll();
    initParallax();
    initScrollProgress();
    initCardReveal();
    initCursorGlow();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', function() {
    initScrollReveal();
    initHeroReveal();
    initChapterReveal();
    initBloodLines();
    initCardReveal();
  });

}());
